import { makeVar } from '@apollo/client';

import { TFieldImportsPageStatus } from './types';

export const fieldImportsPageState = makeVar<TFieldImportsPageStatus>({
	status: 'ADD_FIELDS_FORM',
});
